// Bileli · modules/media/lib — persisted upload progress: the frozen last byte-% AND a liveness
// heartbeat. why: (a) after a reload the UI can show the right «Возобновление N%»; (b) `bytesComplete`
// tells the finalize driver whether bytes actually landed; (c) `updatedAt` lets the resume driver tell a
// LIVE uploader (heartbeat < 10s) from one orphaned by a reload. Writes throttled ~1s; completion always
// persists immediately.

import { lsRead, lsWrite, MEDIA_TTL_MS } from './lsUtil';

const KEY = 'bileli:upload-progress';
const EVENT = 'bileli:upload-progress:changed';
const WRITE_THROTTLE_MS = 1000;

export interface UploadProgressEntry {
  assetId: string;
  pct: number;
  bytesComplete: boolean;
  updatedAt: number;
}

type ProgressMap = Record<string, UploadProgressEntry>;

const lastWrite: Record<string, number> = {};

function readMap(now = Date.now()): ProgressMap {
  const map = lsRead<ProgressMap>(KEY) ?? {};
  let dirty = false;
  for (const id of Object.keys(map)) {
    if (now - map[id].updatedAt >= MEDIA_TTL_MS) {
      delete map[id];
      dirty = true;
    }
  }
  if (dirty) lsWrite(KEY, map, EVENT);
  return map;
}

export function setUploadProgress(assetId: string, pct: number, bytesComplete: boolean, now = Date.now()): void {
  if (!bytesComplete && now - (lastWrite[assetId] ?? 0) < WRITE_THROTTLE_MS) return; // throttle in-flight writes
  lastWrite[assetId] = now;
  const map = readMap(now);
  map[assetId] = { assetId, pct, bytesComplete, updatedAt: now };
  lsWrite(KEY, map, EVENT);
}

export function getUploadProgress(assetId: string, now = Date.now()): UploadProgressEntry | undefined {
  return readMap(now)[assetId];
}

export function clearUploadProgress(assetId: string): void {
  const map = readMap();
  if (map[assetId]) {
    delete map[assetId];
    lsWrite(KEY, map, EVENT);
  }
  delete lastWrite[assetId];
}
